import { useFetchToolsAndSupport } from 'api/queries/useFetchToolsAndSupport'
import { ReactComponent as ArrowIcon } from 'assets/images/icons/arrow-icon.svg'
import { ReactComponent as ExternalLinkIcon } from 'assets/images/icons/external-link-icon.svg'
import { ToolIcon } from 'components/Icon'
import { Icon } from 'components/uikit/Icon/Icon'
import { useIntercom } from 'hooks/useIntercom'
import { AnalyticsActionType } from 'types/analytics.type'
import { TableAppData } from 'types/appData'
import { trackAnalytics } from 'utils/analytics'

import styles from './WorkToolsSubhead.module.scss'
import TitleText from '../common/titleText/TitleText'

const title = 'Tools'
const text = 'Tools and resources to make creating transformative experiences look easy.'

const WorkToolsSubhead = () => {
  const { data: toolsAndSupportData } = useFetchToolsAndSupport({
    params: {
      limit: 250,
      search: '',
      page: 1,
      featured: true,
      sortField: ['name'],
      sortDirection: ['ASC'],
    },
  })
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { showIntercom } = useIntercom()

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleArrowClick = (card: TableAppData) => {
    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: `pg_act_toolsandsupport_tools_${card.name}_${card.description}`,
    })
  }

  const filteredTools = ['KO Total Rewards Hub', 'MAP (Marketing & Agency Platform)']

  return (
    <div className={styles.container}>
      <TitleText
        containerClassName={styles.titleContainer}
        titleClassName={styles.title}
        textClassName={styles.text}
        titleTag="h2"
        textTag="p"
        title={title}
        text={text}
      />
      <div className={styles.contentContainer}>
        {(toolsAndSupportData as any)?.records
          ?.filter((tas: TableAppData) => tas.featured)
          .filter((tas: TableAppData) => !filteredTools.includes(tas.name ?? ''))
          .map((card: TableAppData) => {
            return (
              <div key={card.name} className={styles.cardContainer}>
                <div className={styles.imgContainer}>
                  {/* <img width={30} height={30} src={card.icon} alt={card.name} /> */}
                  <ToolIcon rounded={false} src={card.icon ?? ''} alt={card.name ?? 'tool'} />
                </div>
                <div className={styles.contentWrapper}>
                  <div className={styles.subtitleContainer}>
                    <p className={styles.cardTitle}>{card.name}</p>
                    {card.action === 'external_tool' ? (
                      <a href={card.tool} target="_blank" rel="noreferrer">
                        <Icon icon={ExternalLinkIcon} onClick={() => handleArrowClick(card)} className={styles.icon} />
                      </a>
                    ) : (
                      <a href={card?.tool} target="_blank" rel="noreferrer">
                        <Icon icon={ArrowIcon} className={styles.icon} onClick={() => handleArrowClick(card)} />
                      </a>
                    )}
                  </div>
                  <p className={styles.cardText}>{card.description}</p>
                </div>
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default WorkToolsSubhead
